/* reformly-july4-hero.js */
(function () {
  var section = document.querySelector('.rj4');
  if (!section) return;

  // Both top bars are pinned via CSS position:sticky on .rj4__topbars.
  // Sticky is clipped by any ancestor with overflow/contain set — clear those.
  var topbars = section.querySelector('.rj4__topbars');
  if (topbars) {
    var p = topbars.parentElement;
    while (p && p !== document) {
      var cs = getComputedStyle(p);
      if (cs.overflow !== 'visible') p.style.overflow = 'visible';
      if (cs.overflowX !== 'visible') p.style.overflowX = 'visible';
      if (cs.overflowY !== 'visible') p.style.overflowY = 'visible';
      if (cs.contain && cs.contain !== 'none') p.style.contain = 'none';
      p = p.parentElement;
    }
    // Expose the exact combined bar height so the sticky gallery clears it precisely
    var syncTopbarsH = function () {
      section.style.setProperty('--rj4-topbars-h', topbars.offsetHeight + 'px');
    };
    syncTopbarsH();
    window.addEventListener('resize', syncTopbarsH, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(syncTopbarsH).observe(topbars);
  }

  var pageTemplate = section.getAttribute('data-rj4-template') || '';
  // Per-template analytics: same PostHog project, distinct event prefix +
  // reformly_pageset super-property so each page is separable in reports.
  // Templates not listed here fall through to unprefixed events.
  var PAGESETS = {
    'reformly-30-day-plan': { set: '30-day-plan-v2', prefix: 'r30v2_' },
    'reformly-30-day-plan-adds-discounted': { set: '30-day-plan-adds-discounted', prefix: 'r30d_' },
    'reformly-mini-reformer': { set: 'mini-reformer', prefix: 'rmr_' },
    'reformly-30-day-plan-win': { set: '30-day-plan-win', prefix: 'r30win_' },
    'reformly-30-day-plan-onboarding': { set: '30-day-plan-onboarding', prefix: 'r30ob_' },
    'reformly-30-day-plan-002': { set: '30-day-plan-002', prefix: 'r30x2_' },
    /* Bumped from 'r90_' on 27 Aug 2026 for a clean baseline. The old prefix
       holds test traffic that could not be removed — PostHog deletes by person,
       asynchronously, with no way to purge on demand. Only ~9 page views of
       real data were abandoned. Dashboard 2038213 queries r90live_. */
    'reformly-90-day-plan': { set: '90-day-plan', prefix: 'r90live_' },
    'reformly-30-day-plan02': { set: '30-day-plan-v3', prefix: 'r30v3_' },
    /* app-membership-new loads this engine too but was never listed, so its
       events fell through unprefixed and pooled with every other unlisted
       template — 1,034 of the 1,166 unprefixed page views in 30 days were its.
       It keeps its own landing_* events; these are the engine's. */
    'app-membership-new': { set: 'app-membership-new', prefix: 'amn_' }
  };
  var pageset = PAGESETS[pageTemplate] || null;
  if (pageset && window.posthog && window.posthog.register) {
    window.posthog.register({ reformly_pageset: pageset.set });
  }
  function ph(event, props) {
    if (window.posthog) {
      var p = props || {};
      p.page_template = pageTemplate;
      window.posthog.capture((pageset ? pageset.prefix : '') + event, p);
    }
  }

  ph('reformly_plus_page_view', { url: window.location.href, referrer: document.referrer });

  /* Scroll depth — 25/50/75/100, once each per pageview.
     Ported from reformly-landing-pdp-v2, which has carried this for months;
     these hero templates had no scroll tracking at all. */
  (function () {
    var pageStart = Date.now();
    var fired = {};
    function scrollPct() {
      var top = window.scrollY || document.documentElement.scrollTop;
      var doc = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var win = window.innerHeight;
      if (doc <= win) return 100;
      return Math.round((top / (doc - win)) * 100);
    }
    window.addEventListener('scroll', function () {
      var pct = scrollPct();
      [25, 50, 75, 100].forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          ph('reformly_plus_scroll_depth', {
            depth: t,
            seconds_on_page: Math.round((Date.now() - pageStart) / 1000)
          });
        }
      });
    }, { passive: true });
  })();

  /* FAQ opens. The question text is the label people actually recognise, so
     capture it rather than an index — a reordered FAQ would otherwise silently
     rewrite history.

     Only opens count, not collapses. The open state lives in .is-open on
     .rj4faq-item, but the section's own toggle handler and this one are both
     plain click listeners, so which runs first depends on registration order.
     Reading after a tick sidesteps that entirely: by then the toggle has run
     and the class reflects the post-click state.

     Queried against the document, not `section`: on several templates the FAQ
     is its own Shopify section sitting outside .rj4 (reformly-app-faq on
     app-membership-new, for one), so a section-scoped query finds nothing.
     Both markups are matched — .rj4faq-* in the hero, .ryp-faq2-* in the
     standalone section — and both use .is-open on the item. */
  (function () {
    var sums = document.querySelectorAll('.rj4faq-sum, .ryp-faq2-sum');
    if (!sums.length) return;
    sums.forEach(function (sum) {
      sum.addEventListener('click', function () {
        var item = sum.closest('.rj4faq-item, .ryp-faq2-item');
        var label = sum.querySelector('span');
        setTimeout(function () {
          if (!item || !item.classList.contains('is-open')) return;
          ph('reformly_plus_faq_click', {
            question: label ? label.textContent.trim() : ''
          });
        }, 0);
      });
    });
  })();

  var cartCountEl = section.querySelector('[data-rj4-cart-count]');
  if (cartCountEl) {
    function updateNavCartCount() {
      var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
      if (!cart || !cart.items) return;
      var count = 0;
      cart.items.forEach(function (item) {
        if (!item.properties || !item.properties._free_gift) count += item.quantity;
      });
      cartCountEl.textContent = count;
      cartCountEl.classList.toggle('rj4__hidden', count === 0);
    }
    document.addEventListener('liquid-ajax-cart:request-end', updateNavCartCount);
    document.addEventListener('liquid-ajax-cart:init', updateNavCartCount);
  }


  // Countdown timer — ends at 23:59:59 today (rolling daily)
  var endD = new Date();
  endD.setHours(23, 59, 59, 999);
  var endDate = endD.getTime();
  var cdD = section.querySelector('[data-rj4-cd="d"]');
  var cdH = section.querySelector('[data-rj4-cd="h"]');
  var cdM = section.querySelector('[data-rj4-cd="m"]');
  var cdS = section.querySelector('[data-rj4-cd="s"]');

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function updateCountdown() {
    var diff = Math.max(0, endDate - Date.now());
    var d = Math.floor(diff / 86400000);
    var h = Math.floor(diff / 3600000) % 24;
    var m = Math.floor(diff / 60000) % 60;
    var s = Math.floor(diff / 1000) % 60;
    if (cdD) cdD.textContent = pad(d);
    if (cdH) cdH.textContent = pad(h);
    if (cdM) cdM.textContent = pad(m);
    if (cdS) cdS.textContent = pad(s);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  // Gallery — Swiper
  var galleryEl = section.querySelector('[data-rj4-gallery]');
  var thumbBtns = Array.from(section.querySelectorAll('[data-rj4-thumb]'));
  var cursorEl = section.querySelector('[data-rj4-cursor]');
  var isMobile = function () { return window.innerWidth < 641; };

  var swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 500,
    loop: true,
    grabCursor: false,
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 24 },
      641: { slidesPerView: 1, spaceBetween: 24 }
    }
  };

  var swiper = null;
  var swiperReady = false;

  function updateThumbs(index) {
    thumbBtns.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
    });
    if (swiperReady && thumbBtns[index]) {
      var thumb = thumbBtns[index];
      var container = thumb.parentElement;
      if (container) {
        var scrollLeft = thumb.offsetLeft - (container.offsetWidth / 2) + (thumb.offsetWidth / 2);
        container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
  }

  function bindThumbClicks() {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-rj4-thumb'), 10);
        if (swiper) swiper.slideToLoop(idx);
      });
    });
  }

  // Play the active slide's video only when the gallery is on screen; pause the rest
  var galleryInView = true;
  function syncGalleryVideos() {
    if (!galleryEl) return;
    // use swiper's activeIndex (correct at slideChange time; the .swiper-slide-active
    // class lags a transition in loop mode)
    var active = (swiper && swiper.slides && swiper.slides[swiper.activeIndex]) ||
      galleryEl.querySelector('.swiper-slide-active');
    galleryEl.querySelectorAll('video').forEach(function (v) {
      if (galleryInView && active && active.contains(v)) {
        v.muted = true; // required for programmatic autoplay
        var p = v.play(); if (p && p.catch) p.catch(function () { });
      } else {
        v.pause();
      }
    });
  }
  if (galleryEl && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      galleryInView = entries[0].isIntersecting;
      syncGalleryVideos();
    }, { threshold: 0.25 }).observe(galleryEl);
  }

  /* Gallery reach. Fires once per distinct slide per pageview, not per
     slideChange — a shopper swiping back and forth would otherwise inflate the
     count and make "images viewed per session" meaningless.

     Declared out here, not inside an init, because there are TWO Swiper init
     paths below: initSwiper() for prebuilt markup (app-membership-new uses
     this one) and the colour-swatch rebuild further down. Both must call it. */
  var galleryViewed = {};
  var galleryColor = '';          // set by rebuildGallery when the swatch changes
  function trackGallerySlide(index) {
    if (index === undefined || index === null) return;
    /* rebuildGallery only runs once a swatch is clicked, so views of the
       default colour would otherwise report color: undefined and drop out of
       any colour breakdown. Resolve it from the active swatch on first use. */
    if (!galleryColor) {
      var active = section.querySelector('.rj4__swatch--active');
      galleryColor = (active && active.getAttribute('data-rj4-color')) || '';
    }
    /* Keyed on colour AND index. Changing swatch rebuilds the gallery with
       different photos at the same indices, so keying on index alone would
       suppress them as already-seen; keying on nothing would re-fire every
       slide on every swatch change. Both are wrong — this counts a slide once
       per colour, which is what "images viewed" actually means here. */
    var key = galleryColor + '|' + index;
    if (galleryViewed[key]) return;
    galleryViewed[key] = true;
    ph('reformly_plus_gallery_view', {
      index: index,
      color: galleryColor || undefined,
      images_viewed: Object.keys(galleryViewed).length
    });
  }

  function initSwiper() {
    if (!galleryEl || typeof Swiper === 'undefined') return;
    swiper = new Swiper(galleryEl, swiperConfig);
    trackGallerySlide(swiper.realIndex);
    swiper.on('slideChange', function () {
      updateThumbs(swiper.realIndex);
      syncGalleryVideos();
      trackGallerySlide(swiper.realIndex);
    });
    syncGalleryVideos();
    bindThumbClicks();
  }

  initSwiper();
  setTimeout(function () { swiperReady = true; }, 100);

  if (cursorEl && galleryEl) {
    var cursorSvg = cursorEl.querySelector('svg');

    galleryEl.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      cursorEl.classList.add('is-visible');
    });
    galleryEl.addEventListener('mouseleave', function () {
      cursorEl.classList.remove('is-visible');
    });
    galleryEl.addEventListener('mousemove', function (e) {
      if (isMobile()) return;
      // over a video (its controls) — hide the nav arrow so it doesn't cover them
      if (e.target.closest('video')) { cursorEl.classList.remove('is-visible'); return; }
      cursorEl.classList.add('is-visible');
      var rect = galleryEl.getBoundingClientRect();
      var x = e.clientX - rect.left;
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
      if (x < rect.width / 2) {
        cursorSvg.style.transform = 'scaleX(-1)';
      } else {
        cursorSvg.style.transform = '';
      }
    });

    galleryEl.addEventListener('click', function (e) {
      if (isMobile()) return;
      if (e.target.closest('video')) return; // let the video controls handle clicks
      if (!swiper) return;
      var rect = galleryEl.getBoundingClientRect();
      var x = e.clientX - rect.left;
      if (x >= rect.width / 2) {
        swiper.slideNext();
      } else {
        swiper.slidePrev();
      }
    });
  }

  // Gallery data (per-color metafield images)
  var galleryDataEl = section.querySelector('script[id^="rj4-gallery-data-"]');
  var galleryData = {};
  if (galleryDataEl) {
    try { galleryData = JSON.parse(galleryDataEl.textContent); } catch (e) { }
  }

  function slideMediaHtml(item, i) {
    if (item.type === 'video' && item.sources && item.sources.length) {
      var sources = item.sources.map(function (s) {
        return '<source src="' + s.url + '" type="' + s.mime + '">';
      }).join('');
      return '<video class="rj4__gallery-img" controls playsinline muted loop autoplay preload="metadata"' +
        (item.poster ? ' poster="' + item.poster + '"' : '') + '>' + sources + '</video>';
    }
    return '<img src="' + item.src + '" alt="' + (item.alt || '') + '" class="rj4__gallery-img" loading="' + (i === 0 ? 'eager' : 'lazy') + '">';
  }

  function rebuildGallery(colorKey) {
    var items = galleryData[colorKey];
    if (!items || !items.length) return;
    galleryColor = colorKey;      // scopes the gallery-view dedupe to this colour

    // Destroy old Swiper so loop duplicates are cleaned up
    if (swiper) { swiper.destroy(true, true); swiper = null; }

    // Rebuild slide DOM (images + videos)
    var wrapper = galleryEl.querySelector('.swiper-wrapper');
    wrapper.innerHTML = items.map(function (item, i) {
      return '<div class="rj4__gallery-item swiper-slide" data-media-index="' + (i + 1) + '">' +
        slideMediaHtml(item, i) +
        '</div>';
    }).join('');

    // Reinit Swiper
    swiper = new Swiper(galleryEl, swiperConfig);
    trackGallerySlide(swiper.realIndex);

    swiper.on('slideChange', function () {
      updateThumbs(swiper.realIndex);
      syncGalleryVideos();
      trackGallerySlide(swiper.realIndex);
    });
    // defer so the new video elements + swiper loop clones are in the DOM first
    requestAnimationFrame(syncGalleryVideos);

    // Rebuild thumbs (video uses its poster thumb)
    var thumbsContainer = section.querySelector('[data-rj4-thumbs]');
    if (thumbsContainer) {
      thumbsContainer.innerHTML = items.map(function (item, i) {
        return '<button type="button" class="rj4__thumb' + (i === 0 ? ' is-active' : '') + '" data-rj4-thumb="' + i + '" aria-label="' + (item.alt || '') + '">' +
          '<div class="rj4__thumb-img"><img src="' + item.thumb + '" alt="' + (item.alt || '') + '" loading="lazy"></div>' +
          '<span class="rj4__thumb-bar"></span></button>';
      }).join('');

      thumbBtns = Array.from(thumbsContainer.querySelectorAll('[data-rj4-thumb]'));
      bindThumbClicks();
      // reset the thumb strip to the start so the first (active) thumb is centered
      thumbsContainer.scrollTo({ left: 0 });
      updateThumbs(0);
    }
  }

  // Color selection
  var swatches = section.querySelectorAll('[data-rj4-color]');
  var colorLabel = section.querySelector('[data-rj4-color-name]');

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      var displayColor = sw.getAttribute('data-rj4-color');
      var variantName = sw.getAttribute('data-rj4-variant-name') || displayColor;
      swatches.forEach(function (s) { s.classList.remove('rj4__swatch--active'); });
      sw.classList.add('rj4__swatch--active');
      if (colorLabel) colorLabel.textContent = displayColor;
      rebuildGallery(variantName.toLowerCase());
      ph('reformly_plus_color_select', { color: displayColor });
    });
  });

  // Plan selection
  var planCards = section.querySelectorAll('[data-rj4-plan]');
  var planFeatures = section.querySelectorAll('[data-rj4-plan-features]');
  var stickyTitle = section.querySelector('[data-rj4-sticky-title]');
  var stickyPrice = section.querySelector('[data-rj4-sticky-price]');
  var stickyCompare = section.querySelector('[data-rj4-sticky-compare]');

  function syncSticky(card) {
    if (stickyTitle) {
      stickyTitle.textContent = card.getAttribute('data-rj4-sticky-name') || '';
    }
    if (stickyPrice) {
      stickyPrice.textContent = card.getAttribute('data-rj4-price') || '';
    }
    if (stickyCompare) {
      stickyCompare.textContent = card.getAttribute('data-rj4-compare') || '';
    }
  }

  function selectPlan(card) {
    if (card.classList.contains('rj4__plan-card--active')) return;
    var plan = card.getAttribute('data-rj4-plan');
    planCards.forEach(function (c) {
      c.classList.remove('rj4__plan-card--active');
      c.querySelector('.rj4__plan-radio').classList.remove('rj4__plan-radio--active');
    });
    card.classList.add('rj4__plan-card--active');
    card.querySelector('.rj4__plan-radio').classList.add('rj4__plan-radio--active');

    planFeatures.forEach(function (f) {
      if (f.getAttribute('data-rj4-plan-features') === plan) {
        f.removeAttribute('data-rj4-collapsed');
      } else {
        f.setAttribute('data-rj4-collapsed', '');
      }
    });

    syncSticky(card);
    setTimeout(function () { ph('reformly_plus_plan_select', { plan: plan, price: card.getAttribute('data-rj4-price') }); }, 0);
  }

  var initialPlanCard = section.querySelector('[data-rj4-plan].rj4__plan-card--active');
  if (initialPlanCard) syncSticky(initialPlanCard);

  planCards.forEach(function (card) {
    var touchMoved = false;
    card.addEventListener('touchstart', function () { touchMoved = false; }, { passive: true });
    card.addEventListener('touchmove', function () { touchMoved = true; }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (touchMoved) return;
      e.preventDefault();
      selectPlan(card);
    });
    card.addEventListener('click', function () { selectPlan(card); });
  });

  // FAQ accordion is now self-contained in the hero Liquid (same markup/JS as the
  // bottom FAQ section, scoped by section id) — no handler needed here.

  // Sticky ATC bar
  var stickyBar = section.querySelector('.rj4__sticky');
  var atcBtn = section.querySelector('#rj4-atc-main');

  if (stickyBar && atcBtn) {
    var checkSticky = function () {
      var rect = atcBtn.getBoundingClientRect();
      // account for the pinned top bars — show the sticky ATC once the main button
      // disappears behind them (not only when fully above the viewport)
      var topH = topbars ? topbars.offsetHeight : 0;
      if (rect.bottom < topH) {
        stickyBar.classList.add('rj4__sticky--visible');
      } else {
        stickyBar.classList.remove('rj4__sticky--visible');
      }
    };
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  // Shared spinner SVG
  var SPINNER_SVG = '<svg class="rj4__btn-spinner" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>';

  function setBtnAdding(btn) {
    btn._origText = btn.textContent;
    btn.classList.add('is-adding');
    btn.innerHTML = SPINNER_SVG + '<span>Adding...</span>';
  }

  function setBtnAdded(btn) {
    btn.classList.remove('is-adding');
    btn.textContent = btn._origText || 'Add to Cart';
  }

  function openCartDrawer() {
    // Reformly Plus templates: use the standalone drawer, not the global cart
    if (window.rypCart) { window.rypCart.open(); return; }
    if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.cartRequestUpdate) {
      liquidAjaxCart.cartRequestUpdate();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var cartDrawer = document.querySelector('[data-ajax-cart-section]');
    if (cartDrawer) {
      document.body.classList.add('js-ajax-cart-open');
    }
  }

  // ATC functionality
  var atcButtons = section.querySelectorAll('[data-rj4-atc]');
  atcButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;
      var activeSwatch = section.querySelector('.rj4__swatch--active');
      var activePlan = section.querySelector('.rj4__plan-card--active');
      var variantName = activeSwatch ? (activeSwatch.getAttribute('data-rj4-variant-name') || activeSwatch.getAttribute('data-rj4-color')) : 'lavender';
      var plan = activePlan ? activePlan.getAttribute('data-rj4-plan') : 'monthly';
      var isOnetime = plan === 'onetime';

      setBtnAdding(btn);
      var allAtcBtns = section.querySelectorAll('[data-rj4-atc]');
      allAtcBtns.forEach(function (b) { if (b !== btn) setBtnAdding(b); });

      var items = [];

      if (isOnetime) {
        var otpMap = section.querySelector('[data-rj4-otp-map="' + variantName.toLowerCase() + '"]');
        var otpVariantId = otpMap ? otpMap.getAttribute('data-rj4-otp-val') : '45870676115513';
        items.push({ id: parseInt(otpVariantId), quantity: 1 });
      } else {
        var mapEl = section.querySelector('[data-rj4-variant-map="' + plan + '-' + variantName.toLowerCase() + '"]');
        var variantId = mapEl ? mapEl.getAttribute('data-rj4-variant-val') : null;
        if (!variantId) {
          var fallback = section.querySelector('[data-rj4-variant-map]');
          variantId = fallback ? fallback.getAttribute('data-rj4-variant-val') : null;
        }
        var memVariantId = activePlan ? activePlan.getAttribute('data-rj4-mem-variant') : null;
        if (memVariantId) {
          var memItem = { id: parseInt(memVariantId), quantity: 1 };
          var sellingPlan = activePlan.getAttribute('data-rj4-selling-plan');
          if (sellingPlan) memItem.selling_plan = parseInt(sellingPlan);
          items.push(memItem);
        }
        if (variantId) items.push({ id: parseInt(variantId), quantity: 1 });
        items.push({ id: 45970505039929, quantity: 1 }); // free grip socks
        items.push({ id: 46239945293881, quantity: 1 }); // free personalized nutrition plan
        items.push({ id: 46239947489337, quantity: 1 }); // free express shipping
      }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          /* Stamp the PostHog id onto the cart — see layout/theme.liquid.
             Cannot rely on the cart:refresh listener there: openCartDrawer()
             returns early when window.rypCart exists (the plan-page drawer),
             so on those templates the event is never dispatched. */
          if (window.rfStampCart) rfStampCart();
          allAtcBtns.forEach(function (b) { setBtnAdded(b); });
          openCartDrawer();
          /* The sticky bar and the main CTA share the data-rj4-atc selector and
             this one handler, so without `source` they are indistinguishable in
             reporting. Read off the clicked button, not the DOM, because
             allAtcBtns above has already restyled every one of them. */
          ph('reformly_plus_add_to_cart', {
            plan: plan,
            color: variantName,
            source: btn.classList.contains('rj4__sticky-btn') ? 'sticky' : 'main'
          });
        });
    });
  });

  // Upsell add to cart
  var upsellBtns = section.querySelectorAll('[data-rj4-upsell-add]');
  upsellBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;
      var vid = btn.getAttribute('data-rj4-upsell-add');
      if (!vid) return;
      setBtnAdding(btn);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
      }).then(function (res) { return res.json(); })
        .then(function () {
          /* Same as the main ATC above — openCartDrawer() early-returns on
             plan pages, so nothing in theme.liquid can observe this add. */
          if (window.rfStampCart) rfStampCart();
          setBtnAdded(btn);
          openCartDrawer();
          var upsellCard = btn.closest('.rj4__upsell-card');
          var upsellName = upsellCard ? upsellCard.querySelector('.rj4__upsell-name') : null;
          ph('reformly_plus_upsell_add_to_cart', { variant_id: vid, product: upsellName ? upsellName.textContent.trim() : '' });
        });
    });
  });

  // Video carousel — Swiper
  var videoCarouselEl = section.querySelector('[data-rj4-video-swiper]');
  if (videoCarouselEl && typeof Swiper !== 'undefined') {
    // 002 runs a tighter rail. Set here rather than overriding the slide margin in
    // CSS: Swiper writes spaceBetween as an inline margin and then measures that
    // value to compute its scroll bounds, so a CSS override desyncs the end stop.
    var videoGap = pageTemplate === 'reformly-30-day-plan-002' ? 8 : 12;
    new Swiper(videoCarouselEl, {
      slidesPerView: 'auto',
      spaceBetween: videoGap,
      grabCursor: true,
      freeMode: { enabled: true, sticky: false, momentumRatio: 0.6, momentumVelocityRatio: 0.8, momentumBounce: false },
      threshold: 3,
      touchStartPreventDefault: false,
      resistance: false,
      speed: 400,
      cssMode: false,
      scrollbar: { el: videoCarouselEl.querySelector('.swiper-scrollbar'), draggable: true }
    });
  }

  // Video modal (desktop) / inline play (mobile)
  var vmodal = section.querySelector('[data-rj4-vmodal]');
  var vmodalSwiperEl = section.querySelector('[data-rj4-vmodal-swiper]');
  var vmodalSwiper = null;
  var isMobileDevice = function () { return window.innerWidth < 768; };
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  function stopAllModalVideos() {
    if (!vmodal) return;
    vmodal.querySelectorAll('video').forEach(function (v) {
      v.pause();
      v.currentTime = 0;
      v.muted = true;
    });
    vmodal.querySelectorAll('.rj4__vmodal-slide').forEach(function (s) {
      s.classList.remove('is-unmuted');
    });
  }

  function playModalSlide(idx) {
    if (!vmodalSwiper) return;
    var slides = vmodal.querySelectorAll('.rj4__vmodal-slide');
    slides.forEach(function (s, i) {
      var v = s.querySelector('video');
      if (!v) return;
      if (i === idx) {
        v.play();
      } else {
        v.pause();
        v.currentTime = 0;
      }
    });
  }

  function openModal(slideIdx) {
    if (!vmodal || !vmodalSwiperEl) return;
    vmodal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (!vmodalSwiper) {
      vmodalSwiper = new Swiper(vmodalSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 300
      });
      vmodalSwiper.on('slideChange', function () {
        var idx = vmodalSwiper.activeIndex;
        playModalSlide(idx);
        var slides = vmodal.querySelectorAll('.rj4__vmodal-slide');
        slides.forEach(function (s) { s.classList.remove('is-unmuted'); });
        var active = slides[idx];
        if (active) {
          var v = active.querySelector('video');
          if (v) { v.muted = false; active.classList.add('is-unmuted'); }
        }
      });

      var prevBtn = vmodal.querySelector('[data-rj4-vmodal-prev]');
      var nextBtn = vmodal.querySelector('[data-rj4-vmodal-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { vmodalSwiper.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { vmodalSwiper.slideNext(); });

      vmodal.querySelectorAll('[data-rj4-vmodal-mute]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = btn.closest('.rj4__vmodal-slide');
          var video = slide.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          slide.classList.toggle('is-unmuted', !video.muted);
        });
      });
    }

    vmodalSwiper.slideTo(slideIdx, 0);
    setTimeout(function () {
      playModalSlide(slideIdx);
      var activeSlide = vmodal.querySelectorAll('.rj4__vmodal-slide')[slideIdx];
      if (activeSlide) {
        var v = activeSlide.querySelector('video');
        if (v) {
          v.muted = false;
          activeSlide.classList.add('is-unmuted');
        }
      }
    }, 100);
  }

  function closeModal() {
    if (!vmodal) return;
    stopAllModalVideos();
    vmodal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (vmodal) {
    vmodal.querySelector('[data-rj4-vmodal-close]').addEventListener('click', closeModal);
    vmodal.addEventListener('click', function (e) {
      if (e.target === vmodal) closeModal();
    });
  }

  if (videoCarouselEl) {
    videoCarouselEl.querySelectorAll('.rj4__video-slide').forEach(function (slide, idx) {
      var playBtn = slide.querySelector('.rj4__video-play');
      var video = slide.querySelector('video');
      if (!playBtn || !video) return;

      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();

        if (!isMobileDevice()) {
          openModal(idx);
          return;
        }

        slide.classList.add('is-playing');
        if (isIOS) {
          video.play();
          if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
          else if (video.requestFullscreen) video.requestFullscreen();
        } else {
          video.setAttribute('controls', '');
          video.play();
        }

        if (video.readyState < 3) {
          slide.classList.add('is-loading');
          video.addEventListener('canplay', function handler() {
            slide.classList.remove('is-loading');
            video.removeEventListener('canplay', handler);
          });
        }
      });

      video.addEventListener('ended', function () {
        slide.classList.remove('is-playing');
        video.removeAttribute('controls');
      });
    });
  }
})();
